// Mechanism vocabulary: category -> subcategory -> mechanism.
// Same shape the BioRECIPE table and the annotation window already read:
//   { group: <category>, sections: [{ title: <subcategory>, terms: [<mechanism>, ...] }] }
// A section with title "" holds mechanisms that sit directly under the category.
export const MECHANISM_TAXONOMY = [
  {
    "group": "Protein post-translational modifications",
    "sections": [
      {
        "title": "Phosphate-related",
        "terms": [
          "phosphorylation",
          "serine phosphorylation",
          "threonine phosphorylation",
          "tyrosine phosphorylation",
          "histidine phosphorylation",
          "aspartate phosphorylation",
          "dephosphorylation"
        ]
      },
      {
        "title": "Acetylation/acylation",
        "terms": [
          "acetylation",
          "deacetylation",
          "succinylation",
          "desuccinylation",
          "malonylation",
          "demalonylation",
          "propionylation",
          "depropionylation",
          "butyrylation",
          "debutyrylation",
          "crotonylation",
          "decrotonylation",
          "lactylation",
          "delactylation",
          "glutarylation",
          "benzoylation",
          "formylation",
          "other lysine acylations"
        ]
      },
      {
        "title": "Methylation",
        "terms": [
          "methylation",
          "monomethylation",
          "dimethylation",
          "trimethylation",
          "lysine methylation",
          "arginine methylation",
          "demethylation"
        ]
      },
      {
        "title": "Ubiquitin and ubiquitin-like",
        "terms": [
          "ubiquitination",
          "ubiquitylation",
          "monoubiquitination",
          "multi-monoubiquitination",
          "polyubiquitination",
          "K48-linked ubiquitination",
          "K63-linked ubiquitination",
          "other chain topologies",
          "deubiquitination",
          "SUMOylation",
          "deSUMOylation",
          "NEDDylation",
          "deNEDDylation",
          "ISGylation",
          "deISGylation",
          "UFMylation",
          "deUFMylation",
          "FAT10 conjugation",
          "other ubiquitin-like conjugation"
        ]
      },
      {
        "title": "Glycosylation",
        "terms": [
          "glycosylation",
          "N-linked glycosylation",
          "O-linked glycosylation",
          "C-linked glycosylation",
          "O-GlcNAcylation",
          "O-GalNAcylation",
          "glycosaminoglycan attachment",
          "deglycosylation",
          "de-O-GlcNAcylation",
          "glycan trimming",
          "glycan extension/remodeling",
          "glycation"
        ]
      },
      {
        "title": "Lipidation",
        "terms": [
          "palmitoylation",
          "S-acylation",
          "depalmitoylation",
          "myristoylation",
          "prenylation",
          "farnesylation",
          "geranylgeranylation",
          "GPI anchoring",
          "cholesterylation",
          "phosphatidylethanolamine conjugation",
          "other fatty-acylation/lipid attachment"
        ]
      },
      {
        "title": "ADP-ribose and nucleotide-based",
        "terms": [
          "ADP-ribosylation",
          "mono-ADP-ribosylation",
          "poly-ADP-ribosylation",
          "PARylation",
          "de-ADP-ribosylation",
          "AMPylation",
          "adenylylation",
          "deAMPylation",
          "UMPylation",
          "uridylylation",
          "GMPylation",
          "phosphoribosylation"
        ]
      },
      {
        "title": "Oxidative/redox",
        "terms": [
          "S-nitrosylation",
          "denitrosylation",
          "S-glutathionylation",
          "deglutathionylation",
          "sulfenylation",
          "sulfinylation",
          "sulfonylation",
          "cysteine oxidation",
          "cysteine reduction",
          "methionine oxidation",
          "methionine reduction",
          "protein carbonylation",
          "tyrosine nitration",
          "disulfide-bond formation",
          "disulfide-bond reduction"
        ]
      },
      {
        "title": "Hydroxylation",
        "terms": [
          "hydroxylation",
          "prolyl hydroxylation",
          "lysyl hydroxylation",
          "asparaginyl hydroxylation",
          "tyrosine hydroxylation"
        ]
      },
      {
        "title": "Other covalent PTMs",
        "terms": [
          "sulfation",
          "desulfation",
          "citrullination",
          "deimination",
          "γ-carboxylation",
          "amidation",
          "deamidation",
          "biotinylation",
          "lipoylation",
          "phosphopantetheinylation",
          "iodination",
          "halogenation",
          "glutamylation",
          "deglutamylation",
          "glycylation",
          "deglycylation",
          "transglutamination",
          "covalent cross-linking",
          "isopeptide-bond formation",
          "pyroglutamate formation"
        ]
      }
    ]
  },
  {
    "group": "Protein processing and maturation",
    "sections": [
      {
        "title": "",
        "terms": [
          "proteolytic cleavage",
          "limited proteolysis",
          "precursor cleavage",
          "proprotein processing",
          "signal-peptide cleavage",
          "transit-peptide cleavage",
          "initiator methionine removal",
          "N-terminal processing",
          "C-terminal processing",
          "ectodomain shedding",
          "zymogen activation",
          "protein fragmentation",
          "protein splicing",
          "intein excision",
          "disulfide-bond rearrangement",
          "protein folding",
          "protein refolding",
          "chaperone-mediated folding",
          "conformational maturation"
        ]
      }
    ]
  },
  {
    "group": "Molecular binding and complex formation",
    "sections": [
      {
        "title": "Generic",
        "terms": [
          "binding",
          "association",
          "dissociation",
          "unbinding",
          "complex formation",
          "complex dissociation",
          "recruitment",
          "docking",
          "sequestration",
          "release"
        ]
      },
      {
        "title": "By partner",
        "terms": [
          "protein-protein binding",
          "protein-peptide binding",
          "protein-DNA binding",
          "protein-RNA binding",
          "DNA-DNA interaction",
          "RNA-RNA interaction",
          "DNA-RNA interaction",
          "protein-lipid binding",
          "protein-carbohydrate binding",
          "protein-small-molecule binding",
          "metabolite binding",
          "ligand-receptor binding",
          "antibody-antigen binding",
          "enzyme-substrate binding",
          "cofactor binding",
          "metal-ion binding",
          "nucleotide binding",
          "ATP binding",
          "GTP binding"
        ]
      },
      {
        "title": "Complex architecture",
        "terms": [
          "dimerization",
          "homodimerization",
          "heterodimerization",
          "trimerization",
          "tetramerization",
          "oligomerization",
          "polymerization",
          "depolymerization",
          "multimerization",
          "complex assembly",
          "complex disassembly"
        ]
      }
    ]
  },
  {
    "group": "Conformational and state changes",
    "sections": [
      {
        "title": "",
        "terms": [
          "conformational change",
          "conformational activation",
          "conformational inactivation",
          "folding",
          "unfolding",
          "refolding",
          "domain rearrangement",
          "exposure of binding site",
          "masking of binding site",
          "opening",
          "closing",
          "channel opening",
          "channel closing",
          "receptor conformational change",
          "cis-trans isomerization",
          "proline isomerization"
        ]
      },
      {
        "title": "Nucleotide-dependent switches",
        "terms": [
          "GDP binding",
          "GDP-GTP exchange",
          "nucleotide exchange",
          "GTP hydrolysis",
          "ATP hydrolysis",
          "ADP-ATP exchange"
        ]
      }
    ]
  },
  {
    "group": "Enzymatic biochemical reactions",
    "sections": [
      {
        "title": "Oxidation/reduction",
        "terms": [
          "oxidation",
          "reduction",
          "electron transfer",
          "hydrogen transfer",
          "dehydrogenation",
          "hydrogenation",
          "oxygenation",
          "monooxygenation",
          "dioxygenation",
          "peroxide reduction"
        ]
      },
      {
        "title": "Group transfer",
        "terms": [
          "phosphoryl transfer",
          "methyl transfer",
          "acyl transfer",
          "acetyl transfer",
          "glycosyl transfer",
          "amino-group transfer",
          "transamination",
          "alkyl transfer",
          "sulfur-group transfer",
          "one-carbon-group transfer",
          "nucleotidyl transfer"
        ]
      },
      {
        "title": "Hydrolysis",
        "terms": [
          "hydrolysis",
          "ester hydrolysis",
          "phosphoester hydrolysis",
          "glycosidic-bond hydrolysis",
          "peptide-bond hydrolysis",
          "amide hydrolysis",
          "lipid hydrolysis"
        ]
      },
      {
        "title": "Lyase-type",
        "terms": [
          "bond cleavage without hydrolysis",
          "elimination",
          "addition",
          "decarboxylation",
          "dehydration",
          "hydration",
          "deamination",
          "aldol cleavage"
        ]
      },
      {
        "title": "Isomerization",
        "terms": [
          "isomerization",
          "racemization",
          "epimerization",
          "intramolecular group transfer",
          "mutase reaction"
        ]
      },
      {
        "title": "Ligation",
        "terms": [
          "ligation",
          "condensation",
          "ATP-dependent bond formation",
          "C-C bond formation",
          "C-O bond formation",
          "C-N bond formation",
          "C-S bond formation"
        ]
      }
    ]
  },
  {
    "group": "Metabolic transformations",
    "sections": [
      {
        "title": "",
        "terms": [
          "biosynthesis",
          "synthesis",
          "catabolism",
          "degradation",
          "conversion",
          "cleavage",
          "carboxylation",
          "amination",
          "acylation",
          "deacylation",
          "esterification",
          "de-esterification",
          "cyclization",
          "ring opening",
          "conjugation",
          "deconjugation"
        ]
      }
    ]
  },
  {
    "group": "Transport, translocation, and localization",
    "sections": [
      {
        "title": "Generic",
        "terms": [
          "translocation",
          "localization",
          "relocalization",
          "redistribution",
          "import",
          "export",
          "uptake",
          "efflux",
          "secretion"
        ]
      },
      {
        "title": "Membrane transport",
        "terms": [
          "transmembrane transport",
          "passive diffusion",
          "facilitated diffusion",
          "active transport",
          "primary active transport",
          "secondary active transport",
          "channel-mediated transport",
          "carrier-mediated transport",
          "pump-mediated transport",
          "symport",
          "antiport",
          "exchange transport"
        ]
      },
      {
        "title": "Ion movement",
        "terms": [
          "ion transport",
          "proton transport",
          "sodium transport",
          "potassium transport",
          "calcium transport",
          "chloride transport",
          "ion influx",
          "ion efflux"
        ]
      },
      {
        "title": "Protein trafficking",
        "terms": [
          "nuclear import",
          "nuclear export",
          "nuclear translocation",
          "membrane recruitment",
          "membrane insertion",
          "cytoplasm-to-membrane translocation",
          "ER import",
          "ER export",
          "Golgi transport",
          "mitochondrial import",
          "mitochondrial export",
          "peroxisomal import",
          "lysosomal targeting"
        ]
      },
      {
        "title": "Vesicle-mediated",
        "terms": [
          "vesicle formation",
          "vesicular transport",
          "vesicle docking",
          "vesicle tethering",
          "vesicle fusion",
          "endocytosis",
          "receptor-mediated endocytosis",
          "phagocytosis",
          "pinocytosis",
          "macropinocytosis",
          "exocytosis",
          "endosomal trafficking",
          "recycling",
          "retrograde transport",
          "anterograde transport"
        ]
      }
    ]
  },
  {
    "group": "DNA-related processes",
    "sections": [
      {
        "title": "",
        "terms": [
          "DNA replication",
          "DNA synthesis",
          "replication initiation",
          "replication elongation",
          "replication termination",
          "transcription-factor binding",
          "promoter binding",
          "enhancer binding",
          "repressor binding"
        ]
      },
      {
        "title": "DNA modification",
        "terms": [
          "DNA methylation",
          "DNA demethylation",
          "cytosine hydroxymethylation",
          "further oxidized cytosine modifications",
          "adenine methylation"
        ]
      },
      {
        "title": "Chromatin",
        "terms": [
          "nucleosome assembly",
          "nucleosome disassembly",
          "chromatin remodeling",
          "chromatin opening",
          "chromatin compaction",
          "heterochromatin formation",
          "euchromatin formation",
          "histone acetylation",
          "histone deacetylation",
          "histone methylation",
          "histone demethylation",
          "histone phosphorylation",
          "histone ubiquitination"
        ]
      },
      {
        "title": "Repair/recombination",
        "terms": [
          "DNA cleavage",
          "DNA ligation",
          "DNA repair",
          "base excision",
          "nucleotide excision",
          "mismatch repair",
          "double-strand-break repair",
          "homologous recombination",
          "nonhomologous end joining",
          "DNA recombination",
          "strand exchange"
        ]
      }
    ]
  },
  {
    "group": "Transcription",
    "sections": [
      {
        "title": "",
        "terms": [
          "transcription",
          "transcription initiation",
          "transcription elongation",
          "transcription termination",
          "promoter recruitment",
          "RNA polymerase recruitment",
          "transcription-complex assembly",
          "transcriptional activation",
          "transcriptional repression",
          "transcriptional enhancement",
          "transcriptional silencing"
        ]
      }
    ]
  },
  {
    "group": "RNA processing and regulation",
    "sections": [
      {
        "title": "Maturation",
        "terms": [
          "RNA processing",
          "RNA splicing",
          "alternative splicing",
          "intron removal",
          "exon inclusion",
          "exon skipping",
          "RNA cleavage",
          "RNA ligation",
          "5′ capping",
          "decapping",
          "polyadenylation",
          "deadenylation",
          "uridylation",
          "de-uridylation"
        ]
      },
      {
        "title": "Chemical modification",
        "terms": [
          "RNA methylation",
          "m6A methylation",
          "m5C methylation",
          "other base/ribose methylation",
          "RNA demethylation",
          "pseudouridylation",
          "thiolation",
          "RNA acetylation"
        ]
      },
      {
        "title": "Editing",
        "terms": [
          "RNA editing",
          "A→I editing",
          "C→U editing",
          "U→C editing"
        ]
      },
      {
        "title": "Localization/transport",
        "terms": [
          "nuclear RNA export",
          "nuclear RNA import",
          "RNA localization",
          "mRNA transport"
        ]
      },
      {
        "title": "Stability",
        "terms": [
          "RNA stabilization",
          "RNA destabilization",
          "RNA degradation",
          "mRNA decay",
          "nonsense-mediated decay",
          "exonuclease-mediated degradation",
          "endonucleolytic cleavage"
        ]
      },
      {
        "title": "Small-RNA regulation",
        "terms": [
          "miRNA binding",
          "miRNA-mediated repression",
          "RNA interference",
          "siRNA-mediated silencing",
          "RISC recruitment",
          "mRNA cleavage",
          "translational repression"
        ]
      }
    ]
  },
  {
    "group": "Translation",
    "sections": [
      {
        "title": "",
        "terms": [
          "translation",
          "translation initiation",
          "translation elongation",
          "translation termination",
          "ribosome recruitment",
          "ribosome assembly",
          "ribosome dissociation",
          "translational activation",
          "translation inhibition",
          "translation enhancement",
          "tRNA aminoacylation",
          "codon recognition",
          "peptide-bond formation",
          "polypeptide elongation",
          "cotranslational folding",
          "cotranslational translocation",
          "cotranslational modification"
        ]
      }
    ]
  },
  {
    "group": "Protein turnover and degradation",
    "sections": [
      {
        "title": "",
        "terms": [
          "protein degradation",
          "proteolysis",
          "protease-mediated cleavage",
          "ubiquitin-dependent degradation",
          "ubiquitin-independent degradation",
          "proteasomal degradation",
          "lysosomal degradation",
          "endosomal degradation",
          "autophagic degradation",
          "chaperone-mediated autophagy",
          "ER-associated degradation",
          "ERAD",
          "mitochondrial protein degradation",
          "protein destabilization",
          "protein stabilization",
          "half-life increase",
          "half-life decrease"
        ]
      }
    ]
  },
  {
    "group": "Receptor and signaling mechanisms",
    "sections": [
      {
        "title": "Receptor events",
        "terms": [
          "ligand binding",
          "receptor binding",
          "receptor dimerization",
          "receptor oligomerization",
          "receptor phosphorylation",
          "receptor autophosphorylation",
          "receptor internalization",
          "receptor recycling",
          "receptor degradation",
          "receptor shedding"
        ]
      },
      {
        "title": "G-protein signaling",
        "terms": [
          "G-protein binding",
          "GDP release",
          "GTP loading",
          "guanine-nucleotide exchange",
          "G-protein activation",
          "G-protein inactivation",
          "subunit dissociation",
          "subunit reassociation"
        ]
      },
      {
        "title": "Second messengers",
        "terms": [
          "second-messenger synthesis",
          "second-messenger degradation",
          "cAMP production",
          "cAMP degradation",
          "cGMP production",
          "IP3 production",
          "DAG production",
          "calcium release",
          "calcium influx",
          "calcium efflux"
        ]
      },
      {
        "title": "Ion channels",
        "terms": [
          "channel binding",
          "channel gating",
          "channel activation",
          "channel inhibition",
          "ion permeation"
        ]
      }
    ]
  },
  {
    "group": "Enzyme regulation",
    "sections": [
      {
        "title": "",
        "terms": [
          "substrate binding",
          "product binding",
          "inhibitor binding",
          "activator binding",
          "allosteric binding",
          "allosteric regulation",
          "competitive inhibition",
          "noncompetitive inhibition",
          "uncompetitive inhibition",
          "mixed inhibition",
          "product inhibition",
          "feedback inhibition",
          "feed-forward activation",
          "covalent modification",
          "proteolytic activation",
          "proteolytic inactivation",
          "subunit association",
          "subunit dissociation",
          "cofactor insertion",
          "cofactor removal",
          "localization-dependent regulation"
        ]
      }
    ]
  },
  {
    "group": "Membrane, lipid, and organelle dynamics",
    "sections": [
      {
        "title": "Membrane",
        "terms": [
          "membrane association",
          "membrane dissociation",
          "membrane fusion",
          "membrane fission",
          "budding",
          "tubulation",
          "curvature generation",
          "pore formation",
          "lipid flip-flop",
          "lipid scrambling"
        ]
      },
      {
        "title": "Organelle",
        "terms": [
          "organelle biogenesis",
          "organelle fusion",
          "organelle fission",
          "mitochondrial fusion",
          "mitochondrial fission",
          "ER-organelle contact formation",
          "organelle tethering",
          "organelle inheritance",
          "mitophagy",
          "pexophagy"
        ]
      },
      {
        "title": "Lipid signaling",
        "terms": [
          "lipid synthesis",
          "lipid degradation",
          "phosphoinositide phosphorylation",
          "phosphoinositide dephosphorylation",
          "phospholipid cleavage",
          "eicosanoid synthesis",
          "sterol transport"
        ]
      }
    ]
  },
  {
    "group": "Cytoskeletal, motor, and mechanical",
    "sections": [
      {
        "title": "",
        "terms": [
          "actin polymerization",
          "actin depolymerization",
          "microtubule polymerization",
          "microtubule depolymerization",
          "filament nucleation",
          "branching",
          "bundling",
          "cross-linking",
          "severing",
          "capping",
          "uncapping",
          "motor-protein stepping",
          "ATP-dependent movement",
          "cargo transport",
          "contractility",
          "traction-force generation",
          "mechanotransduction",
          "adhesion assembly",
          "adhesion disassembly",
          "cell migration"
        ]
      }
    ]
  },
  {
    "group": "Quality control, stress, and damage responses",
    "sections": [
      {
        "title": "",
        "terms": [
          "protein quality control",
          "misfolded-protein recognition",
          "chaperone recruitment",
          "unfolded protein response",
          "heat-shock response",
          "oxidative-stress response",
          "DNA-damage signaling",
          "ER stress",
          "proteotoxic stress",
          "aggregate formation",
          "aggregate clearance",
          "autophagy",
          "selective autophagy",
          "apoptotic signaling",
          "necrotic signaling"
        ]
      }
    ]
  },
  {
    "group": "Intercellular and extracellular",
    "sections": [
      {
        "title": "",
        "terms": [
          "cell-cell adhesion",
          "cell-matrix adhesion",
          "extracellular-matrix assembly",
          "matrix degradation",
          "proteoglycan remodeling",
          "ligand secretion",
          "paracrine signaling",
          "autocrine signaling",
          "endocrine signaling",
          "juxtacrine signaling",
          "synaptic transmission",
          "gap-junction communication",
          "extracellular-vesicle release",
          "extracellular-vesicle uptake"
        ]
      }
    ]
  }
];